import { SelectStatusOptionProps } from "@/components"


export const supplyOrderStatusOptions = (
  tEnums: (val: string) => string,
): SelectStatusOptionProps[] => {
  const options = [
    {
      label: tEnums('supply_order_status_pending'),
      value: 'pending',
      variant: 'warning',
    },
    {
      label: tEnums('supply_order_status_completed'),
      value: 'completed',
      variant: 'success',
    },
    {
      label: tEnums('supply_order_status_cancelled'),
      value: 'cancelled',
      variant: 'danger',
    },
  ]

  return options as SelectStatusOptionProps[]
}

export const paymentOptions = (
  tEnums: (val: string) => string,
): SelectStatusOptionProps[] => [
    {
      label: tEnums('order_payment_status_pending'),
      value: 'pending',
      variant: 'warning',
    },
    {
      label: tEnums('order_payment_status_waiting_approval'),
      value: 'waiting_approval',
      variant: 'primary',
    },
    {
      label: tEnums('order_payment_status_paid'),
      value: 'paid',
      variant: 'success',
    },
    {
      label: tEnums('order_payment_status_invalid'),
      value: 'invalid',
      variant: 'danger',
    },
    {
      label: tEnums('order_payment_status_cancelled'),
      value: 'cancelled',
      variant: 'danger',
    },
  ]

export const invoiceOptions = (
  tEnums: (val: string) => string,
): SelectStatusOptionProps[] => [
    {
      label: tEnums('order_invoice_status_pending'),
      value: 'pending',
      variant: 'warning',
    },
    {
      label: tEnums('order_invoice_status_uploaded'),
      value: 'uploaded',
      variant: 'success',
    },
    {
      label: tEnums('order_invoice_status_cancelled'),
      value: 'cancelled',
      variant: 'danger',
    },
  ]

export const shipmentOptions = (
  tEnums: (val: string) => string,
): SelectStatusOptionProps[] => [
    {
      label: tEnums('logistic_shipment_status_pending'),
      value: 'pending',
      variant: 'warning',
    },
    {
      label: tEnums('logistic_shipment_status_delivery_scheduled'),
      value: 'delivery_scheduled',
      variant: 'primary',
    },
    {
      label: tEnums('logistic_shipment_status_in_transit'),
      value: 'in_transit',
      variant: 'primary',
    },
    {
      label: tEnums('logistic_shipment_status_partially_delivered'),
      value: 'partially_delivered',
      variant: 'warning',
    },
    {
      label: tEnums('logistic_shipment_status_delivered'),
      value: 'delivered',
      variant: 'success',
    },
    {
      label: tEnums('logistic_shipment_status_cancelled'),
      value: 'cancelled',
      variant: 'danger',
    },
    {
      label: tEnums('logistic_shipment_status_refused'),
      value: 'refused',
      variant: 'danger',
    },
    {
      label: tEnums('logistic_shipment_status_on_hold'),
      value: 'on_hold',
      variant: 'warning',
    },
  ]